import {Spinner} from '@primer/react'
import {Box} from '@primer/styled-react'

import {TEST_IDS} from '../../constants/test-ids'
import styles from './TimelineDivider.module.css'

type TimelineDividerProps = {
  isLoading?: boolean
  isHovered?: boolean
  id?: string
}

export const TimelineDivider = ({isLoading, isHovered, id}: TimelineDividerProps) => (
  <Box
    sx={{
      justifyContent: isLoading ? 'center' : 'space-between',
    }}
    data-testid={id ? TEST_IDS.timelineDivider(id) : undefined}
    className={styles.Box}
  >
    {isLoading ? (
      <Spinner size={'small'} />
    ) : (
      <>
        <div className={styles.Box_1} />
        <Box
          sx={{
            opacity: isHovered ? 1 : 0,
          }}
          className={styles.Box_2}
        />
      </>
    )}
  </Box>
)

try{ TimelineDivider.displayName ||= 'TimelineDivider' } catch {}